import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isEmpty, now } from "common/generalUtil";
import moment from "moment";
import { initialMCBNS010AutoReservationRemindInfo, MCBNS010AutoReservationRemindInfo } from "pages/MCBNS010/formConfig";
import { initialMCBNS020AutoReservationRemindInfo, MCBNS020AutoReservationRemindInfo, MCBNS020MessageTemplateInfoOutDto } from "pages/MCBNS020/formConfig";
import { MCBNS010InitDisplayRequest } from "types/MCBNS010/MCBNS010InitDisplayRequest";
import { MCBNS010SeminarIdRequest } from "types/MCBNS010/MCBNS010SeminarIdRequest";
import { MCBNS020EditMessageTemplateRequest } from "types/MCBNS020/MCBNS020EditMessageTemplateRequest";
import { MCBNS020updateAutoReservationRemindMessageRequest } from "types/MCBNS020/MCBNS020updateAutoReservationRemindMessageRequest";

interface AutoReservationRemind {
  mCBNS010AutoReservationRemindInfo: MCBNS010AutoReservationRemindInfo
  mCBNS020AutoReservationRemindInfo: MCBNS020AutoReservationRemindInfo
  createDialogOpen: boolean
}
const initialState: AutoReservationRemind = {
  mCBNS010AutoReservationRemindInfo: initialMCBNS010AutoReservationRemindInfo,
  mCBNS020AutoReservationRemindInfo: initialMCBNS020AutoReservationRemindInfo,
  createDialogOpen: false
}
const autoReservationRemindSlice = createSlice({
  name: 'autoReservationRemind',
  initialState,
  reducers: {
    getAutoReservationRemindList(state, action: PayloadAction<MCBNS010InitDisplayRequest>) {
      return state
    },
    setAutoReservationRemindList(state, action: PayloadAction<MCBNS010AutoReservationRemindInfo>) {
      state.mCBNS010AutoReservationRemindInfo = action.payload
      const systemDate = now()
      // 27KH #80788 #11017 Start
      const systemDateStr= moment(systemDate).format('YYYY/MM/DD');
      state.mCBNS010AutoReservationRemindInfo.autoReservationRemindList.map(item => {
        const displayEndDateStr = moment(item.displayEndDate).format('YYYY/MM/DD');
        if (item.displayEndDate && systemDateStr > displayEndDateStr) {
      // 27KH #80788 #11017 End
          item.studentDisplayEnd = true
        } else {
          item.studentDisplayEnd = false
        }
      })
      return state
    },
    editAutoReservationRemind(state, action: PayloadAction<MCBNS010SeminarIdRequest>) {
      return state
    },
    setAutoReservationRemindInfo(state, action: PayloadAction<MCBNS020AutoReservationRemindInfo>) {
      state.mCBNS020AutoReservationRemindInfo = action.payload
      state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId1 = action.payload.messageTemplateSettingId1 ? action.payload.messageTemplateSettingId1.toString() : ''
      state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId2 = action.payload.messageTemplateSettingId2 ? action.payload.messageTemplateSettingId2.toString() : ''
      const systemDate = now()
      // 27KH #80788 #11017 Start
      const systemDateStr1 = moment(systemDate).format('YYYY/MM/DD');
      const displayEndDateStr1 = moment(action.payload.displayEndDate).format('YYYY/MM/DD');
      if (action.payload.displayEndDate && systemDateStr1 > displayEndDateStr1) {
      // 27KH #80788 #11017 End
        action.payload.studentDisplayEnd = true
      } else {
        action.payload.studentDisplayEnd = false
      }
      return state
    },
    setCreateDialogOpen(state, action: PayloadAction<boolean>) {
      state.createDialogOpen = action.payload
      return state
    },
    changeSelectValue(state, action: PayloadAction<{ messageTemplateSettingId: string, name: string }>) {
      if (action.payload.name === 'messageTemplateSettingId1') {
        state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId1 = action.payload.messageTemplateSettingId
      } else if (action.payload.name === 'messageTemplateSettingId2') {
        state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId2 = action.payload.messageTemplateSettingId
      } else if (action.payload.name === 'deliveryTiming1') {
        state.mCBNS020AutoReservationRemindInfo.deliveryTiming1 = action.payload.messageTemplateSettingId
      } else if (action.payload.name === 'deliveryTiming2') {
        state.mCBNS020AutoReservationRemindInfo.deliveryTiming2 = action.payload.messageTemplateSettingId
      } 
      return state
    },
    linkSelectedTemplate(state, action: PayloadAction<{ values: MCBNS020EditMessageTemplateRequest, index: string }>) {
      return state
    },
    confirmAutoReservationRemind(state, action: PayloadAction<MCBNS020updateAutoReservationRemindMessageRequest>) {
      return state
    },
    messageTemplateReload(state, action: PayloadAction<MCBNS020MessageTemplateInfoOutDto[]>) {
      state.mCBNS020AutoReservationRemindInfo.messageTemplateList = action.payload
      const templateIds = action.payload.map(i => {
        return i.messageTemplateSettingId.toString()
      })
      const messageTemplateSetting1 = state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId1
      const messageTemplateSetting2 = state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId2
      if (!templateIds.includes(messageTemplateSetting1)) {
        state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId1 = ''
      }
      if (!templateIds.includes(messageTemplateSetting2)) {
        state.mCBNS020AutoReservationRemindInfo.messageTemplateSettingId2 = ''
      }
      return state
    },
  }
})

export const {
  getAutoReservationRemindList,
  setAutoReservationRemindList,
  editAutoReservationRemind,
  setAutoReservationRemindInfo,
  setCreateDialogOpen,
  changeSelectValue,
  linkSelectedTemplate,
  confirmAutoReservationRemind,
  messageTemplateReload,
} = autoReservationRemindSlice.actions
export default autoReservationRemindSlice.reducer